import { Component, OnInit } from '@angular/core';
import { V2nodeApiService } from 'src/shared/services/v2node-api.service';

@Component({
  selector: 'request-template',
  templateUrl: './request-template.component.html',
  styleUrls: ['./request-template.component.scss']
})
export class RequestTemplateComponent implements OnInit {
  public documentRequestTemplates: any[];
  public messageDataTable: any="";

  constructor(private v2node: V2nodeApiService) { }

  async ngOnInit(): Promise<void> {
    this.documentRequestTemplates = await this.v2node.requestApi({ action: '/document-request-template' });
    const lang = localStorage.getItem('lang')
    switch (lang){
      case 'fr':
        this.messageDataTable = {
          emptyMessage: "Aucun template pour le moment",
          totalMessage: "templates trouvés"
        };
        break
      case 'gb':
        this.messageDataTable = {
          emptyMessage: "No template yet",
          totalMessage: "templates found"
        };
        break
    }
  }
}
